import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockQuoteProps } from '@ts-blocks/block-quote/interfaces'
import type { BlockSectionLayoutProps } from '@ts-blocks/block-section-layout/interfaces'
import type { SectionQuoteProps } from '@ts-sections/section-quote/interfaces'

interface SectionQuoteHookOptions {
  section: () => SectionQuoteProps
}

interface SectionQuoteHookReturn {
  refTitle: ComputedRef<string>
  refDescription: ComputedRef<string>
  refBackgroundColor: ComputedRef<NonNullable<BlockSectionLayoutProps['backgroundColor']>>
  refView: ComputedRef<NonNullable<SectionQuoteProps['view']>>
  refQuotes: ComputedRef<BlockQuoteProps[]>
}

export const useSectionQuote = ({ section }: SectionQuoteHookOptions): SectionQuoteHookReturn => {
  const refLayout = computed<BlockSectionLayoutProps | null>(() => section().layout)

  const refTitle = computed<string>(() => refLayout.value?.title ?? '')
  const refDescription = computed<string>(() => refLayout.value?.description ?? '')

  const refBackgroundColor = computed<NonNullable<BlockSectionLayoutProps['backgroundColor']>>(() => (
    refLayout.value?.backgroundColor ?? 'canvas'
  ))

  const refView = computed<NonNullable<SectionQuoteProps['view']>>(() => section().view ?? 'one')

  const refQuotes = computed<BlockQuoteProps[]>(() => {
    const quote = section().quote
    if (Array.isArray(quote)) return quote
    return quote ? [quote] : []
  })

  return {
    refTitle,
    refDescription,
    refBackgroundColor,
    refView,
    refQuotes,
  }
}
